import { render, staticRenderFns } from "./ExampleSpeciesCount.vue?vue&type=template&id=58ae9d35&"
import script from "./ExampleSpeciesCount.vue?vue&type=script&lang=js&"
export * from "./ExampleSpeciesCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports